export const paginationSearchDelay = 1000;
